/** SHA-256 by WebCrypto (part 16a: every image reference carries its bytes' hash), on the page and in the workers. */

/** The SHA-256 of `bytes`, by `crypto`'s `subtle.digest`. */
export async function sha256(crypto: Crypto, bytes: Uint8Array): Promise<Uint8Array> {
  return new Uint8Array(await crypto.subtle.digest('SHA-256', Uint8Array.from(bytes)));
}
